var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#ADADAD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.684 16.1852C12.8402 15.5468 12.6742 15.2449 12.0586 15.0487C11.9128 15.0021 11.7609 14.9755 11.6126 14.9368C11.2271 14.8364 11.1396 14.5721 11.3953 14.2601C11.4671 14.1723 11.5579 14.0952 11.6527 14.0324C12.7729 13.2918 13.9862 12.8219 15.3433 12.7776C16.4005 12.7471 17.0926 13.1124 17.2962 13.9029C17.3875 14.2578 17.3817 14.6716 17.3004 15.0316C16.9575 16.5521 16.567 18.062 16.2 19.5773C16.0229 20.3081 16.2135 20.6142 16.9457 20.8099C17.0197 20.8298 17.1005 20.8363 17.1669 20.8707C17.325 20.9526 17.5947 21.037 17.6037 21.1393C17.6183 21.3078 17.5106 21.5573 17.3713 21.6579C16.0571 22.6066 14.5954 23.1471 12.9576 23.0209C11.8511 22.9354 11.2672 21.9929 11.5439 20.8402C11.917 19.2865 12.3044 17.7368 12.684 16.1852ZM18.75 8.13634C18.7522 6.738 17.671 5.63431 16.29 5.62506C14.8858 5.61581 13.7577 6.73212 13.7698 8.1198C13.7815 9.50299 14.881 10.5887 16.2746 10.5935C17.6331 10.598 18.748 9.49149 18.75 8.13634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.e3a3870eba44e4fb31b2394a93db9f04.svg";
export { ForwardRef as ReactComponent };